import { useSidebar } from '@folio/components';
import { MenuIcon } from 'lucide-react';
import { Group } from '@folio/components/ui/flex';

function CustomTrigger() {
  const { toggleSidebar } = useSidebar();

  return (
    <button type="button" onClick={toggleSidebar}>
      <MenuIcon className="size-6" />
    </button>
  );
}

export function MobileHeader({ logo }: { logo: React.ReactNode }) {
  return (
    <>
      <div className="bg-sidebar border-b fixed z-10 top-0 left-0 min-w-[100vw] w-full md:hidden">
        <Group justify="between" gap={0} className="p-4">
          {logo}
          <CustomTrigger />
        </Group>
      </div>
      <div className="md:hidden h-16" />
    </>
  );
}
